export const generativeAiAppGroupIdGptAssistant = "/:app_group_id/generative_ai/gpt_assistant";
